<mat-toolbar class="mat-elevation-z6 app-main-toolbar header__toolbar d-print-none">
  <div class="wrapper">
    <div class="wrapper__content" fxLayoutAlign="start center">
      <button id="toggleMenuButton" fxHide.gt-md class="menu-button" mat-icon-button (click)="toggleMenu()">
        <mat-icon>menu</mat-icon>
      </button>
      <img src="assets/img/img_global-credit-BLACK.svg" alt="Logo Global Credit" />
      <div fxFlex></div>
      <button id="supportButtonHeader" mat-stroked-button color="accent" class="support-button" (click)="openDialog()">
        <mat-icon class="icon-ic_help"></mat-icon>
        <span>{{ 'dialog.contacto.title' | translate | uppercase }}</span>
      </button>
      <button id="dropMenuButtonHeader" mat-button class="app-toolbar-user" [matMenuTriggerFor]="userMenu">
        <span class="avatar-initials">{{ username }}</span>
        <mat-icon class="icon-ic_arrow_drop_down"></mat-icon>
      </button>
      <mat-menu id="userMenuHeader" #userMenu="matMenu">
        <mat-list>
          <mat-list-item>
            <span translate>Logged in as</span>&nbsp;<b>{{ username }}</b>
          </mat-list-item>
          <mat-divider></mat-divider>
        </mat-list>
        <button id="changePasswordButtonHeader" mat-menu-item (click)="changePassword()">
          <mat-icon class="icon-ic_password_black"></mat-icon>
          <span class="span_black">{{ 'Password' | translate }}</span>
        </button>
        <button id="logoutButtonHeader" mat-menu-item (click)="logout()">
          <mat-icon class="icon-ic_logout_black"></mat-icon>
          <span class="span_black">{{ 'Logout' | translate }}</span>
        </button>
      </mat-menu>
      <app-language-selector icon="true"></app-language-selector>
    </div>
  </div>
</mat-toolbar>
